export default "__VITE_ASSET__zDcRX_ZB__"